module.exports = __webpack_public_path__ + "img/dashboardIcon.f16ac209.svg";